import { useEffect } from 'react';

const TawkWidget = () => {
  useEffect(() => {
    
    const s1 = document.createElement("script");
    const s0 = document.getElementsByTagName("script")[0];
    
    s1.async = true;
    s1.src = 'https://embed.tawk.to/6761e013af5bfec1dbdd9732/1ifb56jc5';
    s1.charset = 'UTF-8';
    s1.setAttribute('crossorigin', '*');
    
    s0.parentNode.insertBefore(s1, s0);
    
    return () => {
      // Cleanup if needed
      s1.remove();
    };
  }, []);

  return null;
};

export default TawkWidget;